export function sendTotalPriceUpdateEvent({ price, isMonkDiscountApplicable }) {
  document.documentElement.dispatchEvent(
    new CustomEvent('mr:cartTotalUpdate', {
      bubbles: true,
      detail: {
        price,
        isMonkDiscountApplicable,
      },
    }),
  );
}
